export enum Kpis {
  CPI = 1,
  BPI = 2,
  LPI = 3,
  API = 4,
  CHI = 5
}
